import React from 'react'

import './style.scss'

class AppFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__top">
          <div className="row">
            <div className="col-lg-9">
              <p>
                <strong></strong>
              </p>
              <p>
              
              </p>
              <p>
             
              </p>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="row">
            <div className="col-sm-6">
             
            </div>
            <div className="col-sm-6">
              <div className="footer__copyright">
             
                <span>
          
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppFooter



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Footer/index.js